exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-application {\n  height: 50px !important;\n}\n.v-application .primary--text {\n  color: #d2ae6d !important;\n  caret-color: #d2ae6d !important;\n  height: 50px !important;\n  display: none !important;\n}\n.v-date-picker-title {\n  display: none !important;\n  padding: 8px !important;\n}\n.v-picker__title {\n  padding: 8px !important;\n}\n.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {\n  height: 50px !important;\n}\n.v-menu__content {\n  top: 0px !important;\n}", ""]);

// exports
